/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountheading1Inputs */

const en_accountheading1 = /** @type {(inputs: Accountheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account`)
};

const pt_accountheading1 = /** @type {(inputs: Accountheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sua conta`)
};

/**
* | output |
* | --- |
* | "Your account" |
*
* @param {Accountheading1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const accountheading1 = /** @type {((inputs?: Accountheading1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountheading1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accountheading1(inputs)
	return pt_accountheading1(inputs)
});
export { accountheading1 as "accountHeading" }